import { Day } from 'react-modern-calendar-datepicker';

const dateTimeFormatParams = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

export const normalizeDate = (date: Date) => ({
  toDay: (langCode: string): Day => {
    const intl = new Intl.DateTimeFormat(langCode, dateTimeFormatParams);

    const dateParts = intl.formatToParts(new Date(date));

    const day = dateParts.reduce<Day>(
      (acc, item) => {
        if (item.type === 'day') {
          acc.day = Number(item.value);
        }

        if (item.type === 'month') {
          acc.month = Number(item.value);
        }

        if (item.type === 'year') {
          acc.year = Number(item.value);
        }

        return acc;
      },
      { day: 0, month: 0, year: 0 }
    );

    return day;
  },
  toServerDateString: (langCode: string): string => {
    const intl = new Intl.DateTimeFormat(langCode, dateTimeFormatParams);

    const dateParts = intl.formatToParts(new Date(date));

    const day = dateParts.reduce(
      (acc, item) => {
        if (item.type === 'day') {
          acc.day = item.value;
        }

        if (item.type === 'month') {
          acc.month = item.value;
        }

        if (item.type === 'year') {
          acc.year = item.value;
        }

        return acc;
      },
      { day: '', month: '', year: '' }
    );

    return `${day.year}-${day.month}-${day.day}`;
  },
});
